import { createContext, useContext } from 'react';
const ContraEditorContext = createContext({
    fetchWebPageMetadata: () => Promise.resolve({}),
});
export const ContraEditorContextProvider = ContraEditorContext.Provider;
export const useContraEditorContext = () => useContext(ContraEditorContext);
//# sourceMappingURL=ContraEditorContext.js.map